<script setup lang="ts">
type Props = {
  modelValue?: boolean | unknown[];
  label?: string;
};

type Emits = {
  (e: "update:modelValue", value: boolean | unknown[]): void;
};

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  label: "",
});

const emit = defineEmits<Emits>();
</script>

<template>
  <div
    class="flex cursor-pointer items-center"
    @click="emit('update:modelValue', !modelValue)"
  >
    <div
      :class="modelValue ? 'bg-kekkle-purple' : 'bg-white'"
      class="inline-block h-5 w-5 rounded border-2 border-kekkle-dark-dark dark:border-white"
    ></div>
    <label :for="label" class="ml-2 text-kekkle-dark dark:text-slate-200">{{
      label
    }}</label>
  </div>
</template>
